(() => {
  const labels = document.querySelector('[data-qc-zoom-labels]');
  const root = document.querySelector('.pswp');
  if (!labels || !root || typeof PhotoSwipe !== 'function') return;
  const ui = root.querySelector('.pswp__ui');
  const closeButton = root.querySelector('.pswp__button--close');
  const zoomButton = document.createElement('button');
  zoomButton.type = 'button';
  zoomButton.className = 'pswp__button qc-zoom-toggle';
  const counter = document.createElement('span');
  counter.className = 'qc-zoom-count';
  counter.setAttribute('aria-live', 'polite');
  ui.append(zoomButton, counter);
  let active = null;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const update = () => {
    if (!active) return;
    const enlarged = active.getZoomLevel() > active.currItem.initialZoomLevel + 0.01;
    zoomButton.textContent = enlarged ? '−' : '+';
    zoomButton.setAttribute('aria-label', enlarged ? labels.dataset.zoomOut : labels.dataset.zoomIn);
    zoomButton.title = zoomButton.getAttribute('aria-label');
    zoomButton.setAttribute('aria-pressed', String(enlarged));
    counter.textContent = `${labels.dataset.image} ${active.getCurrentIndex() + 1} / ${active.items.length}`;
  };
  zoomButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!active) return;
    const initial = active.currItem.initialZoomLevel;
    const target = active.getZoomLevel() > initial + 0.01 ? initial : Math.max(1, initial * 2);
    active.zoomTo(target, {x: window.innerWidth / 2, y: window.innerHeight / 2}, reducedMotion ? 0 : 180);
    window.setTimeout(update, reducedMotion ? 0 : 200);
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-qc-product-zoom], .qc-product-page .js-product-gallery .product__image');
    if (!trigger || active) return;
    const container = trigger.closest('.b2b-product__gallery, .js-product-gallery');
    if (!container) return;
    const images = Array.from(container.querySelectorAll('img[data-zoom-src]'));
    const image = trigger.matches('img') ? trigger : (trigger.querySelector('img') || trigger.closest('.product-media-container')?.querySelector('img[data-zoom-src]'));
    const index = images.indexOf(image);
    if (index < 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const items = images.map((img) => {
      const originalWidth = Number(img.dataset.width);
      const originalHeight = Number(img.dataset.height);
      const width = Math.min(originalWidth, 2400);
      return {src: img.dataset.zoomSrc, w: width, h: Math.round(originalHeight * width / originalWidth), alt: img.alt};
    });
    let returnFocus = trigger.matches('button') ? trigger : trigger.closest('.product-media-container')?.querySelector('[data-qc-product-zoom]');
    const previousOverflow = document.body.style.overflow;
    const background = document.querySelector('.site-wrap');
    const wasInert = background?.inert;
    root.classList.add('qc-product-zoom');
    root.setAttribute('aria-label', labels.dataset.title);
    root.setAttribute('aria-modal', 'true');
    document.body.style.overflow = 'hidden';
    if (background) background.inert = true;
    const gallery = new PhotoSwipe(root, PhotoSwipeUI_Default, items, {
      index, history: false, closeOnScroll: false, captionEl: false,
      counterEl: false, shareEl: false, fullscreenEl: false, preloaderEl: false,
      zoomEl: false, arrowEl: items.length > 1, tapToClose: false,
      tapToToggleControls: false, clickToCloseNonZoomable: false,
      timeToIdle: 0, showAnimationDuration: reducedMotion ? 0 : 160,
      hideAnimationDuration: reducedMotion ? 0 : 160,
      getDoubleTapZoom: (isMouseClick, item) => Math.max(1, item.initialZoomLevel * 2),
      getThumbBoundsFn: (i) => {const rect = images[i].getBoundingClientRect();return {x:rect.left,y:rect.top+window.scrollY,w:rect.width};}
    });
    active = gallery;
    const updateImageAlts = () => {
      root.querySelectorAll('img.pswp__img').forEach((img) => {
        const item = items.find((entry) => entry.src === img.getAttribute('src'));
        if (item) img.alt = item.alt || '';
      });
    };
    const imageObserver = new MutationObserver(updateImageAlts);
    imageObserver.observe(root, {childList:true, subtree:true});
    const trapFocus = (keyEvent) => {
      if (keyEvent.key !== 'Tab') return;
      const buttons = Array.from(ui.querySelectorAll('button')).filter((button) => button.getClientRects().length && !button.disabled);
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (keyEvent.shiftKey && (document.activeElement === first || !ui.contains(document.activeElement))) {keyEvent.preventDefault();last?.focus();}
      else if (!keyEvent.shiftKey && (document.activeElement === last || !ui.contains(document.activeElement))) {keyEvent.preventDefault();first?.focus();}
    };
    document.addEventListener('keydown', trapFocus);
    gallery.listen('afterChange', () => {
      update();
      const slider = container.querySelector('.js-carousel-main');
      const flickity = slider && window.Flickity?.data(slider);
      const currentImage = images[gallery.getCurrentIndex()];
      const slide = currentImage?.closest('[data-slide-index]');
      if (flickity && slide) {
        flickity.select(Number(slide.dataset.slideIndex), false, true);
        returnFocus = slide.querySelector('[data-qc-product-zoom]') || returnFocus;
      }
      updateImageAlts();
    });
    gallery.listen('zoomGestureEnded', update);
    gallery.listen('doubleTap', () => window.setTimeout(update, 350));
    gallery.listen('destroy', () => {
      active = null;
      imageObserver.disconnect();
      document.removeEventListener('keydown', trapFocus);
      document.body.style.overflow = previousOverflow;
      if (background) background.inert = wasInert;
      root.classList.remove('qc-product-zoom');
      root.removeAttribute('aria-modal');
      returnFocus?.focus({preventScroll:true});
    });
    gallery.listen('initialZoomInEnd', () => closeButton.focus({preventScroll:true}));
    gallery.listen('imageLoadComplete', updateImageAlts);
    gallery.init();
    update();
  }, true);
})();
